<template>
    <v-fade-transition v-if="_user">
        <v-dialog v-if="$vuetify.breakpoint.mdAndUp" v-show="user" max-width="360" content-class="rounded-xl">
            <template #activator="{ attrs, on }">
                <v-btn fixed bottom right fab v-bind="attrs" v-on="on">
                    <v-icon>mdi-qrcode</v-icon>
                </v-btn>
            </template>
            <user-qrcode-card v-bind="{ user }" />
        </v-dialog>
        <v-bottom-sheet v-else v-show="user">
            <template #activator="{ attrs, on }">
                <v-btn fixed bottom right fab v-bind="attrs" v-on="on">
                    <v-icon>mdi-qrcode</v-icon>
                </v-btn>
            </template>
            <user-qrcode-card v-bind="{ user }" class="rounded-t-xl" />
        </v-bottom-sheet>
    </v-fade-transition>
</template>

<script>
import api from "@/api";
import UserQrcodeCard from "./user-qrcode-card.vue";
export default {
    components: {
        UserQrcodeCard,
    },
    data: () => ({
        user: null,
    }),
    computed: {
        _user() {
            return this.$store.state.payload?._user;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        _user() {
            this.init();
        },
    },
    methods: {
        async init() {
            if (this._user) {
                this.user = (await api.v1.me.get())?.user;
            } else this.user = null;
        },
    },
};
</script>

<style>
</style>